export interface MangaChapter {
  id: string;
  title: string;
  updateDate: string;
}

export interface MangaItem {
  id: string;
  title: string;
  author: string;
  coverImage: string;
  category: string;
  subCategory: string;
  description: string;
  status: '连载中' | '已完结';
  rating: number;
  views: number;
  updateDate: string;
  tags: string[];
  chapters: MangaChapter[];
  contentHtml: string;
}

export const mangaList: MangaItem[] = [
  {
    id: 'manga-001',
    title: '剑道至尊',
    author: '林风',
    coverImage: 'https://readdy.ai/api/search-image?query=A%20Chinese%20manhua%20cover%20art%20style%2C%20young%20swordsman%20holding%20a%20glowing%20sword%20in%20ancient%20Chinese%20setting%2C%20dramatic%20lighting%2C%20warm%20orange%20and%20red%20tones%2C%20clean%20composition%20on%20light%20cream%20background%2C%20professional%20manhua%20illustration%20with%20bold%20lines%20and%20dynamic%20pose&width=600&height=800&seq=manga-cover-001&orientation=portrait',
    category: '热血',
    subCategory: '武侠',
    description: '少年林风自幼习剑，在一次意外中获得了上古剑道传承，从此踏上了一条逆天改命的修行之路。面对各方势力的围剿与挑战，他能否凭借手中之剑，斩破一切阻碍，成为真正的剑道至尊？',
    status: '连载中',
    rating: 9.5,
    views: 1280000,
    updateDate: '2026-08-10',
    tags: ['热血', '武侠', '修仙', '战斗'],
    chapters: [
      { id: 'ch-001-1', title: '第1话 剑道初开', updateDate: '2026-01-15' },
      { id: 'ch-001-2', title: '第2话 传承觉醒', updateDate: '2026-01-22' },
      { id: 'ch-001-3', title: '第3话 初入江湖', updateDate: '2026-01-29' },
      { id: 'ch-001-4', title: '第4话 风云际会', updateDate: '2026-02-05' },
      { id: 'ch-001-5', title: '第5话 剑意通明', updateDate: '2026-02-12' },
      { id: 'ch-001-6', title: '第6话 破茧成蝶', updateDate: '2026-02-19' },
      { id: 'ch-001-7', title: '第7话 天外有天', updateDate: '2026-02-26' },
      { id: 'ch-001-8', title: '第8话 决战巅峰', updateDate: '2026-03-05' },
    ],
    contentHtml: '<p>少年林风自幼习剑，在一次意外中获得了上古剑道传承，从此踏上了一条逆天改命的修行之路。面对各方势力的围剿与挑战，他能否凭借手中之剑，斩破一切阻碍，成为真正的剑道至尊？</p><p>本作以中国传统武侠文化为背景，融合修仙元素，画风精美细腻，战斗场面热血澎湃，深受广大读者喜爱。</p>',
  },
  {
    id: 'manga-002',
    title: '星河恋人',
    author: '苏小暖',
    coverImage: 'https://readdy.ai/api/search-image?query=A%20romantic%20Chinese%20manhua%20cover%20art%2C%20young%20couple%20under%20starry%20night%20sky%2C%20soft%20pink%20and%20warm%20peach%20tones%2C%20cherry%20blossom%20petals%20floating%2C%20clean%20cream%20background%2C%20gentle%20and%20dreamy%20atmosphere%2C%20professional%20shoujo%20manhua%20illustration&width=600&height=800&seq=manga-cover-002&orientation=portrait',
    category: '恋爱',
    subCategory: '校园',
    description: '高中生林星辰在一次天文观测中邂逅了转学生顾言，两人因共同的星空爱好而走近。然而，一场意外让顾言不辞而别。三年后，他们在大学重逢，那些未曾说出口的心意，能否在星河下重新绽放？',
    status: '连载中',
    rating: 9.2,
    views: 980000,
    updateDate: '2026-08-09',
    tags: ['恋爱', '校园', '青春', '治愈'],
    chapters: [
      { id: 'ch-002-1', title: '第1话 星空下的邂逅', updateDate: '2026-02-10' },
      { id: 'ch-002-2', title: '第2话 流星下的约定', updateDate: '2026-02-17' },
      { id: 'ch-002-3', title: '第3话 不辞而别', updateDate: '2026-02-24' },
      { id: 'ch-002-4', title: '第4话 三年后的重逢', updateDate: '2026-03-03' },
      { id: 'ch-002-5', title: '第5话 心动的信号', updateDate: '2026-03-10' },
      { id: 'ch-002-6', title: '第6话 雨中漫步', updateDate: '2026-03-17' },
    ],
    contentHtml: '<p>高中生林星辰在一次天文观测中邂逅了转学生顾言，两人因共同的星空爱好而走近。然而，一场意外让顾言不辞而别。三年后，他们在大学重逢，那些未曾说出口的心意，能否在星河下重新绽放？</p><p>本作以校园恋爱为主题，画风清新甜美，情感刻画细腻真实，是一部温暖治愈的青春恋爱漫画。</p>',
  },
  {
    id: 'manga-003',
    title: '暗夜追踪者',
    author: '陈默',
    coverImage: 'https://readdy.ai/api/search-image?query=A%20mystery%20thriller%20Chinese%20manhua%20cover%2C%20detective%20in%20trench%20coat%20standing%20in%20dark%20alley%2C%20silhouette%20with%20dramatic%20shadow%2C%20moody%20atmosphere%2C%20warm%20amber%20street%20light%2C%20clean%20cream%20background%2C%20professional%20manhua%20illustration%20with%20noir%20vibe&width=600&height=800&seq=manga-cover-003&orientation=portrait',
    category: '悬疑',
    subCategory: '推理',
    description: '城市中接连发生离奇案件，警探陆离发现所有线索都指向一个神秘组织。随着调查深入，他逐渐揭开了一个隐藏在城市暗处的惊天秘密。真相与谎言交织，谁才是真正的幕后黑手？',
    status: '已完结',
    rating: 9.6,
    views: 1560000,
    updateDate: '2026-07-20',
    tags: ['悬疑', '推理', '犯罪', '剧情'],
    chapters: [
      { id: 'ch-003-1', title: '第1话 黑夜降临', updateDate: '2025-08-01' },
      { id: 'ch-003-2', title: '第2话 第一个线索', updateDate: '2025-08-08' },
      { id: 'ch-003-3', title: '第3话 迷雾重重', updateDate: '2025-08-15' },
      { id: 'ch-003-4', title: '第4话 突破点', updateDate: '2025-08-22' },
      { id: 'ch-003-5', title: '第5话 真相大白（上）', updateDate: '2025-08-29' },
      { id: 'ch-003-6', title: '第6话 真相大白（下）', updateDate: '2025-09-05' },
      { id: 'ch-003-7', title: '第7话 黎明之前', updateDate: '2025-09-12' },
      { id: 'ch-003-8', title: '第8话 终章·光明', updateDate: '2025-09-19' },
    ],
    contentHtml: '<p>城市中接连发生离奇案件，警探陆离发现所有线索都指向一个神秘组织。随着调查深入，他逐渐揭开了一个隐藏在城市暗处的惊天秘密。真相与谎言交织，谁才是真正的幕后黑手？</p><p>本作以都市悬疑推理为主题，剧情紧凑扣人心弦，人物刻画立体饱满，被誉为近年来最优秀的国产悬疑漫画之一。</p>',
  },
  {
    id: 'manga-004',
    title: '我的室友是妖怪',
    author: '阿宅',
    coverImage: 'https://readdy.ai/api/search-image?query=A%20funny%20comedy%20Chinese%20manhua%20cover%2C%20quirky%20monster%20roommate%20with%20surprised%20human%20character%2C%20colorful%20and%20playful%20style%2C%20warm%20yellow%20and%20orange%20tones%2C%20clean%20cream%20background%2C%20professional%20manhua%20illustration%20with%20exaggerated%20expressions&width=600&height=800&seq=manga-cover-004&orientation=portrait',
    category: '搞笑',
    subCategory: '日常',
    description: '普通大学生张伟的平静生活因为一个来自妖界的室友而彻底改变。从此，他的日常充满了各种啼笑皆非的事件：会说话的猫、爱网购的狐狸精、还有那个总想统治人类世界的房东大人。',
    status: '连载中',
    rating: 9.0,
    views: 850000,
    updateDate: '2026-08-08',
    tags: ['搞笑', '日常', '妖怪', '治愈'],
    chapters: [
      { id: 'ch-004-1', title: '第1话 新室友登场', updateDate: '2026-03-01' },
      { id: 'ch-004-2', title: '第2话 会说话的猫', updateDate: '2026-03-08' },
      { id: 'ch-004-3', title: '第3话 网购达人狐狸精', updateDate: '2026-03-15' },
      { id: 'ch-004-4', title: '第4话 房东的秘密', updateDate: '2026-03-22' },
      { id: 'ch-004-5', title: '第5话 妖界大促销', updateDate: '2026-03-29' },
    ],
    contentHtml: '<p>普通大学生张伟的平静生活因为一个来自妖界的室友而彻底改变。从此，他的日常充满了各种啼笑皆非的事件：会说话的猫、爱网购的狐狸精、还有那个总想统治人类世界的房东大人。</p><p>本作以轻松搞笑的日常喜剧为主，画风Q萌可爱，对话幽默风趣，适合所有年龄段的读者放松心情。</p>',
  },
  {
    id: 'manga-005',
    title: '灵域战神',
    author: '七月雪',
    coverImage: 'https://readdy.ai/api/search-image?query=A%20fantasy%20Chinese%20manhua%20cover%2C%20warrior%20with%20magical%20armor%20in%20ancient%20fantasy%20world%2C%20glowing%20energy%20effects%2C%20epic%20composition%2C%20warm%20golden%20and%20crimson%20tones%2C%20clean%20cream%20background%2C%20professional%20manhua%20illustration&width=600&height=800&seq=manga-cover-005&orientation=portrait',
    category: '奇幻',
    subCategory: '异世界',
    description: '平凡少年叶尘意外穿越到灵气复苏的异世界，在这里，唯有强者才能生存。他凭借前世的记忆和对武道的独特理解，在这个弱肉强食的世界中迅速崛起，成为一代战神。',
    status: '连载中',
    rating: 9.3,
    views: 2100000,
    updateDate: '2026-08-10',
    tags: ['奇幻', '异世界', '战斗', '升级'],
    chapters: [
      { id: 'ch-005-1', title: '第1话 穿越异世界', updateDate: '2026-04-01' },
      { id: 'ch-005-2', title: '第2话 初识灵气', updateDate: '2026-04-08' },
      { id: 'ch-005-3', title: '第3话 武道之路', updateDate: '2026-04-15' },
      { id: 'ch-005-4', title: '第4话 强者为尊', updateDate: '2026-04-22' },
      { id: 'ch-005-5', title: '第5话 名扬天下', updateDate: '2026-04-29' },
      { id: 'ch-005-6', title: '第6话 战神殿', updateDate: '2026-05-06' },
    ],
    contentHtml: '<p>平凡少年叶尘意外穿越到灵气复苏的异世界，在这里，唯有强者才能生存。他凭借前世的记忆和对武道的独特理解，在这个弱肉强食的世界中迅速崛起，成为一代战神。</p><p>本作以奇幻异世界为背景，世界观宏大完整，战斗场面震撼人心，剧情跌宕起伏，是不可多得的奇幻漫画佳作。</p>',
  },
  {
    id: 'manga-006',
    title: '机甲纪元',
    author: '雷神工作室',
    coverImage: 'https://readdy.ai/api/search-image?query=A%20sci-fi%20Chinese%20manhua%20cover%2C%20giant%20mecha%20robot%20in%20futuristic%20city%2C%20pilot%20in%20cockpit%2C%20neon%20lights%20and%20technological%20aesthetic%2C%20warm%20orange%20accent%20on%20dark%20background%2C%20clean%20composition%2C%20professional%20manhua%20illustration&width=600&height=800&seq=manga-cover-006&orientation=portrait',
    category: '科幻',
    subCategory: '机甲',
    description: '公元2150年，人类进入机甲时代。少年机甲师雷明在一次意外中唤醒了传说中的远古机甲——龙渊，从此被卷入了一场关乎人类命运的星际战争。钢铁与热血交织的传奇，就此拉开序幕。',
    status: '连载中',
    rating: 9.4,
    views: 1350000,
    updateDate: '2026-08-07',
    tags: ['科幻', '机甲', '战斗', '未来'],
    chapters: [
      { id: 'ch-006-1', title: '第1话 机甲觉醒', updateDate: '2026-05-01' },
      { id: 'ch-006-2', title: '第2话 龙渊现世', updateDate: '2026-05-08' },
      { id: 'ch-006-3', title: '第3话 初次战斗', updateDate: '2026-05-15' },
      { id: 'ch-006-4', title: '第4话 星际战场', updateDate: '2026-05-22' },
      { id: 'ch-006-5', title: '第5话 钢铁之心', updateDate: '2026-05-29' },
    ],
    contentHtml: '<p>公元2150年，人类进入机甲时代。少年机甲师雷明在一次意外中唤醒了传说中的远古机甲——龙渊，从此被卷入了一场关乎人类命运的星际战争。钢铁与热血交织的传奇，就此拉开序幕。</p><p>本作将科幻与机甲元素完美融合，画面充满未来科技感，机甲设计精良，战斗场面火爆震撼。</p>',
  },
  {
    id: 'manga-007',
    title: '深海迷踪',
    author: '深海',
    coverImage: 'https://readdy.ai/api/search-image?query=An%20adventure%20Chinese%20manhua%20cover%2C%20divers%20exploring%20ancient%20underwater%20ruins%2C%20mysterious%20deep%20sea%20atmosphere%2C%20bioluminescent%20creatures%2C%20warm%20teal%20and%20coral%20tones%2C%20clean%20cream%20background%2C%20professional%20manhua%20illustration&width=600&height=800&seq=manga-cover-007&orientation=portrait',
    category: '冒险',
    subCategory: '探险',
    description: '海洋学家苏沫在一次深海考察中发现了失落的亚特兰蒂斯遗迹。为了揭开深海文明的神秘面纱，她组建了一支探险队，深入万米海底。然而，等待他们的不仅是未知的宝藏，还有远古的守护者。',
    status: '已完结',
    rating: 9.1,
    views: 720000,
    updateDate: '2026-06-15',
    tags: ['冒险', '探险', '海洋', '科幻'],
    chapters: [
      { id: 'ch-007-1', title: '第1话 深海信号', updateDate: '2025-10-01' },
      { id: 'ch-007-2', title: '第2话 遗迹之门', updateDate: '2025-10-08' },
      { id: 'ch-007-3', title: '第3话 失落文明', updateDate: '2025-10-15' },
      { id: 'ch-007-4', title: '第4话 守护者', updateDate: '2025-10-22' },
      { id: 'ch-007-5', title: '第5话 最终抉择', updateDate: '2025-10-29' },
      { id: 'ch-007-6', title: '第6话 归途', updateDate: '2025-11-05' },
    ],
    contentHtml: '<p>海洋学家苏沫在一次深海考察中发现了失落的亚特兰蒂斯遗迹。为了揭开深海文明的神秘面纱，她组建了一支探险队，深入万米海底。然而，等待他们的不仅是未知的宝藏，还有远古的守护者。</p><p>本作以深海探险为主题，画面精美绝伦，海底世界的描绘令人叹为观止，是一部兼具科学与幻想的冒险漫画。</p>',
  },
  {
    id: 'manga-008',
    title: '校园风云录',
    author: '小叮当',
    coverImage: 'https://readdy.ai/api/search-image?query=A%20school%20life%20Chinese%20manhua%20cover%2C%20group%20of%20high%20school%20students%20in%20uniform%2C%20cherry%20blossom%20campus%2C%20warm%20spring%20tones%2C%20youthful%20and%20energetic%2C%20clean%20cream%20background%2C%20professional%20manhua%20illustration&width=600&height=800&seq=manga-cover-008&orientation=portrait',
    category: '校园',
    subCategory: '青春',
    description: '樱华高中二年三班，一群性格迥异的学生，一段难忘的青春岁月。从运动会到文化祭，从考试焦虑到毕业分别，每一个平凡的日子都闪耀着不平凡的光芒。这是一部关于青春、友情和成长的故事。',
    status: '连载中',
    rating: 8.9,
    views: 650000,
    updateDate: '2026-08-06',
    tags: ['校园', '青春', '友情', '成长'],
    chapters: [
      { id: 'ch-008-1', title: '第1话 开学第一天', updateDate: '2026-06-01' },
      { id: 'ch-008-2', title: '第2话 同桌的你', updateDate: '2026-06-08' },
      { id: 'ch-008-3', title: '第3话 运动会', updateDate: '2026-06-15' },
      { id: 'ch-008-4', title: '第4话 文化祭', updateDate: '2026-06-22' },
    ],
    contentHtml: '<p>樱华高中二年三班，一群性格迥异的学生，一段难忘的青春岁月。从运动会到文化祭，从考试焦虑到毕业分别，每一个平凡的日子都闪耀着不平凡的光芒。这是一部关于青春、友情和成长的故事。</p><p>本作以真实校园生活为题材，人物形象鲜明生动，情感真挚动人，是一部让人回忆起青春岁月的温暖漫画。</p>',
  },
  {
    id: 'manga-009',
    title: '炎龙传说',
    author: '火龙果',
    coverImage: 'https://readdy.ai/api/search-image?query=A%20Chinese%20dragon%20fantasy%20manhua%20cover%2C%20young%20dragon%20warrior%20riding%20a%20fire%20dragon%2C%20ancient%20Chinese%20palace%20in%20background%2C%20epic%20and%20majestic%2C%20warm%20red%20and%20gold%20tones%2C%20clean%20cream%20background%2C%20professional%20manhua%20illustration&width=600&height=800&seq=manga-cover-009&orientation=portrait',
    category: '热血',
    subCategory: '仙侠',
    description: '龙族后裔炎辰，身怀上古炎龙血脉，被天下仙门视为异类。他历经磨难，从被追杀的少年成长为威震天下的龙帝。当远古封印松动，魔族卷土重来，他必须站出来守护这片他深爱的天地。',
    status: '连载中',
    rating: 9.7,
    views: 1890000,
    updateDate: '2026-08-10',
    tags: ['热血', '仙侠', '龙族', '战斗'],
    chapters: [
      { id: 'ch-009-1', title: '第1话 龙裔觉醒', updateDate: '2026-05-10' },
      { id: 'ch-009-2', title: '第2话 仙门追杀', updateDate: '2026-05-17' },
      { id: 'ch-009-3', title: '第3话 炎龙之怒', updateDate: '2026-05-24' },
      { id: 'ch-009-4', title: '第4话 龙谷秘境', updateDate: '2026-05-31' },
      { id: 'ch-009-5', title: '第5话 龙帝归来', updateDate: '2026-06-07' },
      { id: 'ch-009-6', title: '第6话 魔族入侵', updateDate: '2026-06-14' },
      { id: 'ch-009-7', title: '第7话 天地之战', updateDate: '2026-06-21' },
    ],
    contentHtml: '<p>龙族后裔炎辰，身怀上古炎龙血脉，被天下仙门视为异类。他历经磨难，从被追杀的少年成长为威震天下的龙帝。当远古封印松动，魔族卷土重来，他必须站出来守护这片他深爱的天地。</p><p>本作融合中国传统神话元素，画风大气磅礴，龙族设定独树一帜，是一部气势恢宏的热血仙侠漫画。</p>',
  },
  {
    id: 'manga-010',
    title: '恋爱方程式',
    author: '蜜糖',
    coverImage: 'https://readdy.ai/api/search-image?query=A%20sweet%20romance%20Chinese%20manhua%20cover%2C%20young%20couple%20sharing%20earbuds%20in%20library%2C%20warm%20sunlight%20streaming%20through%20window%2C%20soft%20pastel%20peach%20tones%2C%20clean%20cream%20background%2C%20professional%20shoujo%20manhua%20illustration&width=600&height=800&seq=manga-cover-010&orientation=portrait',
    category: '恋爱',
    subCategory: '都市',
    description: '程序员李默和设计师唐糖在同一栋写字楼工作，每天在电梯里擦肩而过。一次偶然的项目合作让他们真正认识彼此。两个不同世界的人，因为一款恋爱模拟游戏的设计而碰撞出了意想不到的火花。',
    status: '连载中',
    rating: 9.0,
    views: 560000,
    updateDate: '2026-08-05',
    tags: ['恋爱', '都市', '职场', '甜宠'],
    chapters: [
      { id: 'ch-010-1', title: '第1话 电梯里的陌生人', updateDate: '2026-06-10' },
      { id: 'ch-010-2', title: '第2话 项目合作', updateDate: '2026-06-17' },
      { id: 'ch-010-3', title: '第3话 代码与画笔', updateDate: '2026-06-24' },
      { id: 'ch-010-4', title: '第4话 意外的告白', updateDate: '2026-07-01' },
    ],
    contentHtml: '<p>程序员李默和设计师唐糖在同一栋写字楼工作，每天在电梯里擦肩而过。一次偶然的项目合作让他们真正认识彼此。两个不同世界的人，因为一款恋爱模拟游戏的设计而碰撞出了意想不到的火花。</p><p>本作以都市职场为背景，讲述了一段甜蜜而真实的办公室恋情，画风清新时尚，是当代都市恋爱漫画的代表作。</p>',
  },
  {
    id: 'manga-011',
    title: '第十三号档案',
    author: '夜不语',
    coverImage: 'https://readdy.ai/api/search-image?query=A%20horror%20mystery%20Chinese%20manhua%20cover%2C%20old%20case%20files%20on%20desk%20with%20bloody%20handprint%2C%20dim%20detective%20office%2C%20eerie%20atmosphere%2C%20warm%20amber%20desk%20lamp%2C%20clean%20cream%20background%2C%20professional%20manhua%20illustration&width=600&height=800&seq=manga-cover-011&orientation=portrait',
    category: '悬疑',
    subCategory: '惊悚',
    description: '退休刑警老周收到了一份神秘档案——第十三号档案，里面记录着三十年前一桩悬案的诡异细节。当他开始重新调查时，发现这桩案件远比想象中更加恐怖。档案中的每一个线索，都将引向一个不可言说的真相。',
    status: '连载中',
    rating: 9.5,
    views: 1100000,
    updateDate: '2026-08-08',
    tags: ['悬疑', '惊悚', '推理', '剧情'],
    chapters: [
      { id: 'ch-011-1', title: '第1话 神秘档案', updateDate: '2026-04-10' },
      { id: 'ch-011-2', title: '第2话 尘封的记忆', updateDate: '2026-04-17' },
      { id: 'ch-011-3', title: '第3话 第一具尸体', updateDate: '2026-04-24' },
      { id: 'ch-011-4', title: '第4话 诡秘符号', updateDate: '2026-05-01' },
      { id: 'ch-011-5', title: '第5话 深渊凝视', updateDate: '2026-05-08' },
    ],
    contentHtml: '<p>退休刑警老周收到了一份神秘档案——第十三号档案，里面记录着三十年前一桩悬案的诡异细节。当他开始重新调查时，发现这桩案件远比想象中更加恐怖。档案中的每一个线索，都将引向一个不可言说的真相。</p><p>本作以悬疑惊悚为主题，氛围营造出神入化，剧情反转令人拍案叫绝，是悬疑漫画爱好者不可错过的佳作。</p>',
  },
  {
    id: 'manga-012',
    title: '废柴逆袭系统',
    author: '段子手阿强',
    coverImage: 'https://readdy.ai/api/search-image?query=A%20comedy%20system%20Chinese%20manhua%20cover%2C%20average%20guy%20suddenly%20surrounded%20by%20game-like%20status%20windows%2C%20funny%20surprised%20expression%2C%20colorful%20video%20game%20UI%20elements%2C%20warm%20yellow%20tones%2C%20clean%20cream%20background%2C%20professional%20manhua%20illustration&width=600&height=800&seq=manga-cover-012&orientation=portrait',
    category: '搞笑',
    subCategory: '系统流',
    description: '社畜程序员王大力意外绑定了废柴逆袭系统，从此人生开启了各种离谱的挑战任务。从\"连续加班30天\"到\"向暗恋对象表白\"，每一个任务都让人哭笑不得。但最离谱的是，这些任务完成后获得的奖励竟然真的能改变他的人生！',
    status: '连载中',
    rating: 8.8,
    views: 920000,
    updateDate: '2026-08-09',
    tags: ['搞笑', '系统流', '都市', '逆袭'],
    chapters: [
      { id: 'ch-012-1', title: '第1话 绑定系统', updateDate: '2026-06-01' },
      { id: 'ch-012-2', title: '第2话 加班任务', updateDate: '2026-06-08' },
      { id: 'ch-012-3', title: '第3话 表白挑战', updateDate: '2026-06-15' },
      { id: 'ch-012-4', title: '第4话 逆袭之路', updateDate: '2026-06-22' },
      { id: 'ch-012-5', title: '第5话 系统升级', updateDate: '2026-06-29' },
    ],
    contentHtml: '<p>社畜程序员王大力意外绑定了废柴逆袭系统，从此人生开启了各种离谱的挑战任务。每一个任务都让人哭笑不得，但最离谱的是，这些任务完成后获得的奖励竟然真的能改变他的人生！</p><p>本作以系统流搞笑为主题，梗多笑点密集，让人在捧腹大笑的同时也能感受到主角的成长与蜕变。</p>',
  },
];

export const categories = [
  { slug: 'rexue', name: '热血', icon: 'ri-fire-line', description: '燃爆全场的战斗与成长' },
  { slug: 'lianai', name: '恋爱', icon: 'ri-heart-line', description: '甜蜜浪漫的心动故事' },
  { slug: 'xuanyi', name: '悬疑', icon: 'ri-search-eye-line', description: '扣人心弦的推理悬疑' },
  { slug: 'gaoxiao', name: '搞笑', icon: 'ri-emotion-laugh-line', description: '轻松欢乐的日常喜剧' },
  { slug: 'qihuan', name: '奇幻', icon: 'ri-magic-line', description: '瑰丽宏大的幻想世界' },
  { slug: 'kehuan', name: '科幻', icon: 'ri-rocket-line', description: '未来科技的无限想象' },
  { slug: 'maoxian', name: '冒险', icon: 'ri-compass-3-line', description: '惊险刺激的探险之旅' },
  { slug: 'xiaoyuan', name: '校园', icon: 'ri-building-line', description: '青春洋溢的校园生活' },
];

export const categorySlugMap: Record<string, string> = {
  'rexue': '热血',
  'lianai': '恋爱',
  'xuanyi': '悬疑',
  'gaoxiao': '搞笑',
  'qihuan': '奇幻',
  'kehuan': '科幻',
  'maoxian': '冒险',
  'xiaoyuan': '校园',
};

export const categoryNameMap: Record<string, string> = {
  '热血': 'rexue',
  '恋爱': 'lianai',
  '悬疑': 'xuanyi',
  '搞笑': 'gaoxiao',
  '奇幻': 'qihuan',
  '科幻': 'kehuan',
  '冒险': 'maoxian',
  '校园': 'xiaoyuan',
};